//ALIASES
export const CLIENTS = 'clients';
export const SITES = 'sites';
export const PLACES = 'places';

//ROUTES
export const CLIENT_USERS_LIST_ROUTE = 'user-list/client';
export const SITE_USERS_LIST_ROUTE = 'user-list/site';
export const PLACE_USERS_LIST_ROUTE = 'user-list/place';
export const INTERVENTIONS_ROUTE = 'interventions';
export const CONTRACTS_ROUTE = 'contracts';
export const AUDITS_ROUTE = 'audits';
export const DISORDERS_TREATMENT_ROUTE = 'disorders-treatment';
export const EDIT_CLIENT_ROUTE = 'edit/client';
export const EDIT_SITE_ROUTE = 'edit/site';
export const EDIT_PLACE_ROUTE = 'edit/place';
export const EDIT_SITE_PARENT_ROUTE = 'edit/site/parent';
export const CREATE_SITE_ROUTE = 'create/site';
export const CREATE_PLACE_ROUTE = 'create/place';
export const CREATE_CLIENT_ROUTE = 'create/client';
export const ADD_ROUTE = 'add';
export const CLIENTS_ROUTE = 'clients';
export const SITES_ROUTE = 'sites';
export const PLACES_ROUTE = 'places';
export const EDIT_ROUTE = 'edit';
export const ADD_DATE_ROUTE = 'planned-date';
export const ASSIGN_SITE_ROUTE = 'assign/site';
export const ASSIGN_CLIENT_ROUTE = 'assign/client';
export const ASSIGN_PLACE_ROUTE = 'assign/place';
export const CHANGE_PASS_ROUTE = 'change-pass';
export const DELETE_USER_ROUTE = 'delete-user';
export const DELETE_MANAGER_PLACE_ROUTE = 'delete-manager-place';
export const EDIT_USER_ROUTE = 'edit_user';
export const REMOVE_USER_FROM_AGENCY_ROUTE = 'remove-user-from-agency';
export const NAVIGATION_ROUTE = 'navigation';
export const AGENDA_ROUTE = 'agenda';
export const MAP_ROUTE = 'map';
export const USERS_ROUTE = 'users';
export const AGENCY_ROUTE = 'agencies';
export const CONTRACTS_TYPES_ROUTE = 'contracts-types';
export const DEVIS_ROUTE = 'devis';
export const EXPORT_ROUTE = 'export';
export const GET_TOKEN_FROM_URL_ROUTE = 'get-token-from-url';

//RESOURCES
export const AVATARS = 'avatars';
export const AVATAR_V1 = 'avatar_v1s';
export const AVATARS_GROUP = 'group_avatars';
export const GROUP_USERS = 'group_users';
export const FINGERS = 'fingers';
export const AVATAR_PROPERTIES = `avatar_properties`;
export const METADATA_AVATAR_TYPE_PROPERTIES = `metadata_avatar_type_properties`;
export const COMPANIES = 'companies';
export const METADATA_AVATAR_TYPES = 'metadata_avatar_types';
export const GROUP_METADATA_AVATAR_TYPES = 'group_metadata_avatar_types';
export const MCS = 'm_cs';
export const AVATAR_TRACEABILITY_NOTES = 'avatar_traceability_notes';
export const MEDIA = 'media';
export const MEDIAS = 'medias';
export const COUNTER = 'counter';
export const TOKEN_CONNECTED = 'token-connected';
export const USERS = 'users';
export const MANAGER_PLACES = 'ticketing/manager_places';
export const PLACES_OR_EVENTS = 'ticketing/places_or_events';
export const PROFILES = 'profiles';
export const TRACEABILITY_TRACKING_V2_CHANGE_NODE_1 = 'traceability/tracking/v2/change-node-1';
export const CHANGE_NODE_BY_HUMAN_ID = 'avatars/change_node_by_human_id';
export const GROUP_AVATARS = 'group_avatars';
export const AVATARS_ADD_GROUP_AVATARS = 'avatars/add_group_avatars';
export const CHANGE_DEMANDS_TO = 'big/resource/change-demands-to';
export const AVATARS_MOVE_TO = 'avatars/move_to';
export const METABASE_VIEWS_VIEWS_DYNAMIC = 'views/viewsdynamic';
export const CHANGE_PASSWORD = 'v2/users/change_password';
export const MAP_BOX_GEO_POSITIONS = 'map/box-geo-positions';
export const CREATE_AGENCY = 'big/resource/create-agency';
export const BIG_RESOURCE_RESET_DEMO = 'big/resource/reset-demo';

//TYPES
export const CLIENT_METADATA_AVATAR_TYPE_NAME = 'big:type:client';
export const SITES_METADATA_AVATAR_TYPE_NAME = 'big:type:site';
export const PLACES_METADATA_AVATAR_TYPE_NAME = 'big:type:place';
export const INTERVENTION_METADATA_AVATAR_TYPE_NAME = 'big:type:intervention';
export const AUDIT_METADATA_AVATAR_TYPE_NAME = 'big:type:audit';
export const CONTRACT_METADATA_AVATAR_TYPE_ALPHA_ID = 'big:type:contract';
export const TREATMENT_METADATA_AVATAR_TYPE_NAME = 'big:type:treatment';
export const DISORDER_METADATA_AVATAR_TYPE_NAME = 'big:type:disorder';
export const FILE_MEDIA_TYPE = 'FILE';
export const MEDIA_IMAGE_TYPE = 'IMAGE';

//AVATAR_PROPERTIES
export const CONTACT_NAME_AVATAR_PROPERTY = 'contact_name';
export const CONTACT_PHONE_AVATAR_PROPERTY = 'contact_phone';
export const CONTACT_EMAIL_AVATAR_PROPERTY = 'contact_email';
export const PLANNED_DATE_AVATAR_PROPERTY = 'planed:date';
export const START_DATE_AVATAR_PROPERTY = 'start:date';
export const END_DATE_AVATAR_PROPERTY = 'end:date';
export const INTERVENTION_CREATED_FROM_AVATAR_PROPERTY = 'intervention:created:from';
export const VALIDATED_UNTIL_DATE_AVATAR_PROPERTY = 'validatedUntilDate';
export const INTERVENTION_STATUS_AVATAR_PROPERTY = 'status';

//ENV VARIABLES
export const FINGER_ID: any = import.meta.env.VITE_FINGER_ID;
export const TOKEN_KEY: any = import.meta.env.VITE_LOCALSTORAGE_TOKEN_KEY;
export const REFRESH_TOKEN_KEY: any = `${TOKEN_KEY}_refresh`;
export const TOKEN_WITHOUT_ROLES_KEY: any = `${TOKEN_KEY}_without_roles`;
export const API_ENTRYPOINT_V1 = import.meta.env.VITE_API_ENTRYPOINT_V1 as string;
export const API_ENTRYPOINT_V2 = import.meta.env.VITE_API_ENTRYPOINT_V2 as string;
export const METABASE_ENTRYPOINT = import.meta.env.VITE_METABASE_ENTRYPOINT;
export const METABASE_ENTRYPOINT_URI = import.meta.env.VITE_METABASE_ENTRYPOINT_URI;
export const API_ENTRYPOINT_URI = import.meta.env.VITE_API_URI;
export const FILE_SYSTEM_MAPPER_ENTRYPOINT = import.meta.env.VITE_FILE_SYSTEM_MAPPER_ENTRYPOINT;
export const FILE_SYSTEM_MAPPER_ENTRYPOINT_URI = import.meta.env.VITE_FILE_SYSTEM_MAPPER_ENTRYPOINT_URI;
export const COUNTER_SERVICE_ENTRYPOINT = import.meta.env.VITE_COUNTER_SERVICE_ENTRYPOINT as string;
export const PUBLIC_DOCUMENTS_URL_DOWNLOAD = import.meta.env.VITE_PUBLIC_DOCUMENTS_URL_DOWNLOAD as string;
export const GEOCODE_APIKEY = import.meta.env.VITE_GEOCODE_APIKEY;
/** Misma referencia en todos los renders para `LoadScript` / `Loader` de Google Maps (evita recargar el script). */
export const GOOGLE_MAPS_LIBRARIES: Array<'places'> = ['places'];
export const API_SS = import.meta.env.VITE_API_SS;
export const API_SS_URI = import.meta.env.VITE_API_SS_URI;
export const EXPORT_PDF_ENTRYPOINT = import.meta.env.VITE_EXPORT_PDF_ENTRYPOINT as string;

//CONST
export const STATUS_NAME_VALUES = ['En attente de réalisation', 'Planifiée', 'Réalisée', 'Annulée'];
// export const STATUS_NAME_VALUES = ['En attente de réalisation', 'Annulée'];
export const INTERVENTION_TYPE_NAME_UNDER_QUOTE = 'under_quote';
export const INTERVENTION_TYPE_NAME_PREVENTIVE = 'preventive';
export const INTERVENTION_TYPE_NAME_AUDIT_OUT_OF_CONTRACT = 'audit_out_of_contract';
export const INTERVENTION_TYPE_NAME_VALUES = [
    INTERVENTION_TYPE_NAME_UNDER_QUOTE,
    INTERVENTION_TYPE_NAME_PREVENTIVE,
    INTERVENTION_TYPE_NAME_AUDIT_OUT_OF_CONTRACT,
];
export const DISORDER_TYPE_NAME_VALUES = ['disorder', 'treatment'];
export const USER_RESOURCE_SUPPORTED = 'user';
export const AVATAR_RESOURCE_SUPPORTED = 'avatar';
export const METADATA_AVATAR_TYPE_RESOURCE_SUPPORTED = 'metadata_avatar_type';
export const TICKETING_LOGO_MEDIA_TAG_NAME = 'ticketing_logo';
export const MAX_ALLOWED_SIZE_FILE = 5;
export const GROUP_AVATAR_SITE_AGENCY_PREFIX = 'group-user:agency:';
export const GROUP_AVATAR_SITE_PREFIX = 'g:sites:';
export const GROUP_AVATAR_PLACE_PREFIX = 'g:places:';
// Grupo de avatares "default" donde deben quedar los clientes (avatars tipo client)
export const DEFAULT_CLIENTS_GROUP_AVATAR_ALPHA_ID = 'g:default:clients';
// Backward-compat / nombre histórico (si alguien ya lo importó en otra rama)
export const GROUP_AVATAR_CLIENT = DEFAULT_CLIENTS_GROUP_AVATAR_ALPHA_ID;

export const SUB_MANAGER_TAG = 'ticketing_sub_manager';
export const MANAGER_TAG = 'ticketing_manager';
export const CONDITION_SERVICE_TAG = 'condition_service';
export const BIG_SUB_MANAGER_CLIENT_TAG = 'big_manager_client';
export const BIG_SUB_MANAGER_SITE_TAG = 'big_manager_site';
export const BIG_MANAGER_TAG = 'big_manager';

export const AUDIT_STATE_AUDIT = 'Audit';
export const AUDIT_STATE_AUDIT_HUMAN_ID = '0008';

export const AUDIT_STATE_TAKE_INTO_ACCOUNT = 'Pris en compte';
export const AUDIT_STATE_TAKE_INTO_ACCOUNT_HUMAN_ID = '0009';

export const AUDIT_STATE_CANCELED = 'Annulé';
export const AUDIT_STATE_CANCELED_HUMAN_ID = '0010';

export const AUDIT_STATE_DONE = 'Réalisée';
export const AUDIT_STATE_DONE_HUMAN_ID = '0011';

export const AUDIT_STATUS_NODES_LIST = [
    {
        id: AUDIT_STATE_AUDIT_HUMAN_ID,
        name: 'audit.list.nodes.audit',
    },
    {
        id: AUDIT_STATE_TAKE_INTO_ACCOUNT_HUMAN_ID,
        name: 'audit.list.nodes.take_account',
        disabled: true,
    },
    {
        id: AUDIT_STATE_CANCELED_HUMAN_ID,
        name: 'audit.list.nodes.cancel',
    },
    {
        id: AUDIT_STATE_DONE_HUMAN_ID,
        name: 'audit.list.nodes.done',
        disabled: true,
    },
];

// PROFILES
export const BIG_SUPER_ADMIN = 'BIG_SUPER_ADMIN';
export const BIG_ADMIN = 'BIG_ADMIN';
export const BIG_OPERATOR = 'BIG_OPERATOR';
export const BIG_CLIENT_ADMIN = 'BIG_CLIENT_ADMIN';
// export const BIG_CLIENT_ADMIN = 'BIG_CLIENT_ADMIN';
export const BIG_CLIENT_SITE_MANAGER = 'BIG_CLIENT_SITE_MANAGER';
export const BIG_CLIENT_SITE_OPERATOR = 'BIG_CLIENT_SITE_OPERATOR';
// export const BIG_CLIENT_SITE_OPERATOR_CREATE_SITE = 'BIG_CLIENT_SITE_OPERATOR_CREATE_SITE';
export const BIG_AGENCY_MANAGER = 'BIG_AGENCY_MANAGER';
export const BIG_AGENCY_ADMIN = 'agency-admin';
export const BIG_AGENCY_OPERATOR = 'BIG_AGENCY_OPERATOR';
export const TIERS_GESTIONNAIRE_CLIENTS = 'TIERS_GESTIONNAIRE_CLIENTS';

export const USER_PROFILES = [
    BIG_SUPER_ADMIN,
    BIG_ADMIN,
    BIG_OPERATOR,
    BIG_CLIENT_ADMIN,
    BIG_CLIENT_SITE_MANAGER,
    BIG_CLIENT_SITE_OPERATOR,
    BIG_AGENCY_MANAGER,
    BIG_AGENCY_OPERATOR,
    TIERS_GESTIONNAIRE_CLIENTS,
];

export const SUB_MANAGER_PROFILE = 'JEFFREY_MANAGER_SUB_ADMIN';
export const MANAGER_CLIENT_PROFILE = 'JEFFREY_MANAGER_CLIENT_ADMIN';

//COUNTER SERVICES TYPES
export const INCIDENT_SERVICE_CONTRACT = 'incident_service:contract';
export const INCIDENT_SERVICE_CLIENT = 'incident_service:client';
export const INCIDENT_SERVICE_INTERVENTION = 'incident_service:intervention';
export const INCIDENT_SERVICE_SITE = 'incident_service:site';
export const INCIDENT_SERVICE_PLACE = 'incident_service:place';
export const INCIDENT_SERVICE_DEVIS = 'incident_service:devis';
export const INCIDENT_SERVICE_AUDIT = 'incident_service:audit';
export const INCIDENT_SERVICE_AGENCY = 'incident_service:agency';

// MAPPERS
export const DEFAULT_MAPPER = 'DEFAULT_MAPPER';
export const PUBLIC_NOTE_MAPPER =
    'Platform360\\Service\\NoteBook\\Domain\\TypeNote\\ClassMapperData\\PublicNote\\PublicNoteClassMapperData';
export const GLOBAL_NOTE_MAPPER = 'Platform360\\Service\\NoteBook\\Domain\\GlobalNote\\GlobalNote';

//ROLES
export const ROLE_BIG_READ_CLIENT = 'ROLE_BIG_READ_CLIENT';
export const ROLE_BIG_UPDATE_CLIENT = 'ROLE_BIG_UPDATE_CLIENT';
export const ROLE_BIG_CREATE_CLIENT = 'ROLE_BIG_CREATE_CLIENT';
export const ROLE_BIG_DELETE_CLIENT = 'ROLE_BIG_DELETE_CLIENT';
export const ROLE_BIG_READ_SITE = 'ROLE_BIG_READ_SITE';
export const ROLE_BIG_UPDATE_SITE = 'ROLE_BIG_UPDATE_SITE';
export const ROLE_BIG_CREATE_SITE = 'ROLE_BIG_CREATE_SITE';
export const ROLE_BIG_DELETE_SITE = 'ROLE_BIG_DELETE_SITE';
export const ROLE_BIG_READ_PLACE = 'ROLE_BIG_READ_PLACE';
export const ROLE_BIG_UPDATE_PLACE = 'ROLE_BIG_UPDATE_PLACE';
export const ROLE_BIG_CREATE_PLACE = 'ROLE_BIG_CREATE_PLACE';
export const ROLE_BIG_DELETE_PLACE = 'ROLE_BIG_DELETE_PLACE';
export const ROLE_BIG_READ_DEMAND = 'ROLE_BIG_READ_DEMAND';
export const ROLE_BIG_DELETE_DEMAND = 'ROLE_BIG_DELETE_DEMAND';
export const ROLE_BIG_UPDATE_DEMAND_STATUS = 'ROLE_BIG_UPDATE_DEMAND_STATUS';
export const ROLE_BIG_CREATE_QUOTE = 'ROLE_BIG_CREATE_QUOTE';
export const ROLE_BIG_READ_INTERVENTION = 'ROLE_BIG_READ_INTERVENTION';
export const ROLE_BIG_CREATE_INTERVENTION = 'ROLE_BIG_CREATE_INTERVENTION';
export const ROLE_BIG_DELETE_INTERVENTION = 'ROLE_BIG_DELETE_INTERVENTION';
export const ROLE_BIG_PLANED_DATE_INTERVENTION = 'ROLE_BIG_PLANED_DATE_INTERVENTION';
export const ROLE_BIG_UPDATE_INTERVENTION_STATUS = 'ROLE_BIG_UPDATE_INTERVENTION_STATUS';
export const ROLE_BIG_READ_CONTRACT = 'ROLE_BIG_READ_CONTRACT';
export const ROLE_BIG_CREATE_CONTRACT = 'ROLE_BIG_CREATE_CONTRACT';
export const ROLE_BIG_DELETE_CONTRACT = 'ROLE_BIG_DELETE_CONTRACT';
export const ROLE_BIG_READ_QUOTE = 'ROLE_BIG_READ_QUOTE';
export const ROLE_BIG_DELETE_QUOTE = 'ROLE_BIG_DELETE_QUOTE';
export const ROLE_BIG_LINK_USER_TO_CLIENT = 'ROLE_BIG_LINK_USER_TO_CLIENT';
export const ROLE_BIG_LINK_USER_TO_SITE = 'ROLE_BIG_LINK_USER_TO_SITE';
export const ROLE_BIG_LINK_USER_TO_PLACE = 'ROLE_BIG_LINK_USER_TO_PLACE';
export const ROLE_BIG_CHANGE_PARENT_SITE = 'ROLE_BIG_CHANGE_PARENT_SITE';
export const ROLE_BIG_READ_CONTRACT_TYPE = 'ROLE_BIG_READ_CONTRACT_TYPE';
export const ROLE_CREATE_USER = 'ROLE_CREATE_USER';
export const ROLE_DELETE_USER = 'ROLE_DELETE_USER';
export const ROLE_BIG_READ_AUDIT = 'ROLE_BIG_READ_AUDIT';
export const ROLE_BIG_UPDATE_AUDIT = 'ROLE_BIG_UPDATE_AUDIT';
export const ROLE_BIG_READ_AGENDA = 'ROLE_BIG_READ_AGENDA';
export const ROLE_BIG_DEMO = 'ROLE_BIG_DEMO';

export const EN_ATTENTE_REALISATION_STATE_KEY = 'en_attente_realisation';
export const PLANIFIEE_STATE_KEY = 'planifiee';
export const ANNULEE_STATE_KEY = 'annulee';
export const REALISEE_STATE_KEY = 'realisee';

export const INTERVENTION_CHANGE_STATUS_NODE_LIST_OBJECT = {
    [EN_ATTENTE_REALISATION_STATE_KEY]: {
        id: '0013',
        name: 'intervention.actions.change_status.nodes.en_attente _realisation',
    },
    [PLANIFIEE_STATE_KEY]: {
        id: '0014',
        name: 'intervention.actions.change_status.nodes.planifiee',
        disabled: true,
    },
    [ANNULEE_STATE_KEY]: {
        id: '0015',
        name: 'intervention.actions.change_status.nodes.annulee',
    },
    [REALISEE_STATE_KEY]: {
        id: '0016',
        name: 'intervention.actions.change_status.nodes.realisee',
        disabled: true,
    },
};

export const TO_EVALUATE_STATE_KEY = 'to_evaluate';
export const TAKEN_INTO_ACCOUNT_STATE_KEY = 'taken_into_account';
export const ARCHIVED_AND_PROCESSED_STATE_KEY = 'archived_and_processed';

export const DISORDER_CHANGE_STATUS_NODE_LIST = {
    [TO_EVALUATE_STATE_KEY]: {
        id: '0010',
        name: 'disorder.actions.change_status.nodes.to_evaluate',
    },
    [TAKEN_INTO_ACCOUNT_STATE_KEY]: {
        id: '0011',
        name: 'disorder.actions.change_status.nodes.taken_into_account',
    },
    [ARCHIVED_AND_PROCESSED_STATE_KEY]: {
        id: '0012',
        name: 'disorder.actions.change_status.nodes.archived_and_processed',
    },
};

export const REFRESH_TOKEN_URL_QUERY_PARAM = 'refreshToken';
export const REDIRECT_TO_URL_QUERY_PARAMS = 'redirectTo';

export const AUDIT_AVATAR_NAME = 'audit';

//CURATIVE FORMS NAMES
export const CURATIVE_FORM_ABRASION_WEAR_LAYER_NAME = 'abrasion_wear_layer';
export const CURATIVE_FORM_ANKLE_IMPACT_NAME = 'ankle_impact';
export const CURATIVE_FORM_CRACK_NAME = 'crack';
export const CURATIVE_FORM_FLATNESS_NAME = 'flatness';
export const CURATIVE_FORM_OTHERS_NAME = 'others';
export const CURATIVE_FORM_PAVING_IMPACT_NAME = 'paving_impact';
export const CURATIVE_FORM_PIANAGE_NAME = 'pianage';
export const CURATIVE_FORM_SPALLS_NAME = 'spalls';

export const CURATIVE_CHOICES = [
    CURATIVE_FORM_ABRASION_WEAR_LAYER_NAME,
    CURATIVE_FORM_ANKLE_IMPACT_NAME,
    CURATIVE_FORM_CRACK_NAME,
    CURATIVE_FORM_FLATNESS_NAME,
    CURATIVE_FORM_OTHERS_NAME,
    CURATIVE_FORM_PAVING_IMPACT_NAME,
    CURATIVE_FORM_PIANAGE_NAME,
    CURATIVE_FORM_SPALLS_NAME,
];

export const CURATIVE_AVATARS_NAMES: any = {
    [CURATIVE_FORM_ABRASION_WEAR_LAYER_NAME]: "Abrasion couche d'usure",
    [CURATIVE_FORM_ANKLE_IMPACT_NAME]: 'Impact cheville',
    [CURATIVE_FORM_CRACK_NAME]: 'Fissures',
    [CURATIVE_FORM_FLATNESS_NAME]: 'Planéité',
    [CURATIVE_FORM_OTHERS_NAME]: 'Autres',
    [CURATIVE_FORM_PAVING_IMPACT_NAME]: 'Impact dallage',
    [CURATIVE_FORM_PIANAGE_NAME]: 'Pianotage',
    [CURATIVE_FORM_SPALLS_NAME]: 'Épaufrures',
};

//TREATMENT FORMS NAMES
export const TREATMENT_FORM_CLASSIC_PROTECTIVE_LAYER_NAME = 'classic_protective_layer';
export const TREATMENT_FORM_COLORING_OF_PAVING_OUTSIDE_AGGREGATE_NAME = 'coloring_of_paving_outside_aggregate';
export const TREATMENT_FORM_COVERING_PAVING_MARKING_COLORING_NAME = 'covering_paving_marking_coloring';
export const TREATMENT_FORM_EXTERIOR_HARDENER_DESNSIFICATION_NAME = 'exterior_hardener_desnsification';
export const TREATMENT_FORM_HARDENER_INTERIOR_DENSIFICATION_WATER_REPELLENT_NAME =
    'hardener_interior_densification_water_repellent';
export const TREATMENT_FORM_HARDENER_INTERIOR_DESINFICATION_NAME = 'hardener_interior_desinfication';
export const TREATMENT_FORM_HIGH_TRAFFIC_PROTECTION_LAYER_NAME = 'high_traffic_protection_layer';
export const TREATMENT_FORM_SANDING_NAME = 'sanding';
export const TREATMENT_FORM_STRIPPING_NAME = 'stripping';
export const TREATMENT_FORM_SURFACE_CLEANING_NAME = 'surface_cleaning';

export const TREATMENT_CHOICES = [
    TREATMENT_FORM_CLASSIC_PROTECTIVE_LAYER_NAME,
    TREATMENT_FORM_COLORING_OF_PAVING_OUTSIDE_AGGREGATE_NAME,
    TREATMENT_FORM_COVERING_PAVING_MARKING_COLORING_NAME,
    TREATMENT_FORM_EXTERIOR_HARDENER_DESNSIFICATION_NAME,
    TREATMENT_FORM_HARDENER_INTERIOR_DENSIFICATION_WATER_REPELLENT_NAME,
    TREATMENT_FORM_HARDENER_INTERIOR_DESINFICATION_NAME,
    TREATMENT_FORM_HIGH_TRAFFIC_PROTECTION_LAYER_NAME,
    TREATMENT_FORM_SANDING_NAME,
    TREATMENT_FORM_STRIPPING_NAME,
    TREATMENT_FORM_SURFACE_CLEANING_NAME,
];

export const TREATMENT_AVATARS_NAMES: any = {
    [TREATMENT_FORM_CLASSIC_PROTECTIVE_LAYER_NAME]: 'Couche de protection classique',
    [TREATMENT_FORM_COLORING_OF_PAVING_OUTSIDE_AGGREGATE_NAME]: 'Coloration dallage hors agregat',
    [TREATMENT_FORM_COVERING_PAVING_MARKING_COLORING_NAME]: 'Coloration couverante dallage / marquage',
    [TREATMENT_FORM_EXTERIOR_HARDENER_DESNSIFICATION_NAME]: 'Durcisseur + Desnsification extérieur',
    [TREATMENT_FORM_HARDENER_INTERIOR_DENSIFICATION_WATER_REPELLENT_NAME]:
        'Durcisseur + Densification intérieur + hydrofuge',
    [TREATMENT_FORM_HARDENER_INTERIOR_DESINFICATION_NAME]: 'Durcisseur + Desinfication intérieur',
    [TREATMENT_FORM_HIGH_TRAFFIC_PROTECTION_LAYER_NAME]: 'Couche de protection fort trafic',
    [TREATMENT_FORM_SANDING_NAME]: 'Ponçage',
    [TREATMENT_FORM_STRIPPING_NAME]: 'Décapage',
    [TREATMENT_FORM_SURFACE_CLEANING_NAME]: 'Nettoyage de surface',
};

export const AVATAR_GROUP_STANDARD_TYPE = 'standard';
export const AVATAR_GROUP_QUOTE_TYPE = 'quote';
export const AVATAR_GROUP_AUDIT_TYPE = 'audit';
export const GROUP_METADATA_AVATAR_TYPE_NAME = 'Contract';
export const AVATAR_PROPERTY_DEFINITION_NAME = 'Contract';

export const FICHE_RENSEIGNEMENTS_DOCUMENT_TAG = 'fiche_renseignements';
export const FICHE_MISE_SERVICE_TAG = 'fiche_mise_service';
export const DOE_DOCUMENT_TAG = 'doe';
export const INITIAL_AUDIT_TAG = 'initial_audit';
export const SERVICE_CONDITIONS_TAG = 'service_conditions';
export const INTERVENTION_EXPORT_TAG = 'intervention_export';
export const DISORDER_TREATMENT_EXPORT_TAG = 'disorder_treatment_export';

//SITE INPUTS NAMES
export const ADDRESS_TEXT = 'addressText';
export const POSTAL_CODE = 'postalCode';
export const COUNTRY = 'country';
export const CITY = 'city';

export const CURRENT_CLIENT_NAVIGATION_STORE_KEY = 'currentClientNavigation';
